import React from "react";

import { Box, Button, Stack } from "@mui/material";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const SectionTabs = ({ sections, initialId }: { sections: any[]; initialId?: any }) => {
    const [activeId, setActiveId] = React.useState(initialId || sections?.[0]?.id);
    const active = sections.find((s) => s.id === activeId) || sections[0];

    return (
        <Stack spacing={3}>
            <Stack
                direction="row"
                spacing={2}
                flexWrap="wrap"
                sx={{
                    gap: 1.2,
                    pb: 2,
                    borderBottom: "2px solid #f0f0f0"
                }}
            >
                {sections.map((section) => (
                    <Button
                        key={section.id}
                        size="small"
                        variant={activeId === section.id ? "contained" : "outlined"}
                        onClick={() => setActiveId(section.id)}
                        sx={{
                            borderRadius: "28px",
                            textTransform: "none",
                            px: 3,
                            py: 1,
                            fontSize: 13,
                            fontWeight: 700,
                            transition: "all 0.4s cubic-bezier(0.4, 0, 0.2, 1)",
                            background:
                                activeId === section.id
                                    ? "linear-gradient(135deg, #2fbf71 0%, #27a864 100%)"
                                    : "#f8f9fa",
                            color: activeId === section.id ? "#fff" : "#1f3a2e",
                            border:
                                activeId === section.id
                                    ? "2px solid #2fbf71"
                                    : "2px solid #ddd",
                            boxShadow:
                                activeId === section.id
                                    ? "0 8px 20px rgba(129,196,187,0.35)"
                                    : "0 2px 8px rgba(0,0,0,0.05)",
                            "&:hover": {
                                background:
                                    activeId === section.id
                                        ? "linear-gradient(135deg, #27a864 0%, #23995a 100%)"
                                        : "rgba(129,196,187,0.12)",
                                borderColor: "#2fbf71",
                                transform: "translateY(-2px)",
                                boxShadow:
                                    activeId === section.id
                                        ? "0 12px 24px rgba(129,196,187,0.4)"
                                        : "0 4px 12px rgba(129,196,187,0.2)"
                            }
                        }}
                    >
                        {section.label}
                    </Button>
                ))}
            </Stack>
            <Box sx={{ mt: 3 }}>{active?.content}</Box>
        </Stack>
    );
};

export default SectionTabs;
